<template>
  <div class="animated fadeInRight ecommerce">
    <el-row v-show="componentShow === 'sysDocumentList'">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('sysDocumentManage.queryCondition') }}</span>
            <el-button 
              style="float: right; padding: 3px 0" 
              type="text"
              @click="toggleMoreCondition"
            >
              {{ moreCondition ? $t('sysDocumentManage.hide') : $t('sysDocumentManage.more') }}
            </el-button>
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item>
                <el-input
                  v-model="conditions.docCode"
                  :placeholder="$t('sysDocumentManage.inputDocCode')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <el-input
                  v-model="conditions.docTitle"
                  :placeholder="$t('sysDocumentManage.inputDocTitle')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input
                  v-model="conditions.docId"
                  :placeholder="$t('sysDocumentManage.inputDocId')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button 
                type="primary" 
                icon="el-icon-search"
                @click="querySysDocumentMethod"
              >
                {{ $t('sysDocumentManage.query') }}
              </el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row v-show="componentShow === 'sysDocumentList'">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('sysDocumentManage.documentInfo') }}</span>
            <el-button 
              style="float: right; padding: 3px 0" 
              type="primary"
              icon="el-icon-plus"
              @click="openAddSysDocumentModal"
            >
              {{ $t('sysDocumentManage.add') }}
            </el-button>
          </div>
          <el-table
            :data="sysDocuments"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="docTitle"
              :label="$t('sysDocumentManage.docTitle')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="docCode"
              :label="$t('sysDocumentManage.docCode')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="docId"
              :label="$t('sysDocumentManage.docId')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              :label="$t('sysDocumentManage.createTime')"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('sysDocumentManage.operation')"
              align="right"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="openEditSysDocumentModel(scope.row)"
                >
                  {{ $t('sysDocumentManage.edit') }}
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="openDeleteSysDocumentModel(scope.row)"
                >
                  {{ $t('sysDocumentManage.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total"
            style="margin-top: 20px; text-align: right"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-sys-document-view 
      v-if="componentShow === 'addSysDocumentView'"
      ref="addSysDocumentView"
      @close="handleCloseAdd"
    ></add-sys-document-view>

    <edit-sys-document-view 
      v-if="componentShow === 'editSysDocumentView'"
      ref="editSysDocumentView"
      @close="handleCloseEdit"
    ></edit-sys-document-view>

    <delete-sys-document 
      ref="deleteSysDocument"
      @close="handleCloseDelete"
    ></delete-sys-document>
  </div>
</template>

<script>
import { getSysDocumentList } from '@/api/dev/sysDocument/sysDocumentApi'
import AddSysDocumentView from '@/components/dev/addSysDocumentView/addSysDocumentView'
import EditSysDocumentView from '@/components/dev/editSysDocumentView/editSysDocumentView'
import DeleteSysDocument from '@/components/dev/deleteSysDocument/deleteSysDocument'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'SysDocumentManage',
  components: {
    AddSysDocumentView,
    EditSysDocumentView,
    DeleteSysDocument
  },
  data() {
    return {
      componentShow: 'sysDocumentList',
      sysDocuments: [],
      conditions: {
        docTitle: '',
        docCode: '',
        docId: ''
      },
      moreCondition: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this.listSysDocuments()
  },
  methods: {
    async listSysDocuments() {
      try {
        const params = {
          ...this.conditions,
          page: this.currentPage,
          row: this.pageSize,
          shopId: this.shopId
        }
        const res = await getSysDocumentList(params)
        this.sysDocuments = res.data
        this.total = res.total
      } catch (error) {
        console.error('获取文档列表失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.listSysDocuments()
    },
    querySysDocumentMethod() {
      this.currentPage = 1
      this.listSysDocuments()
    },
    toggleMoreCondition() {
      this.moreCondition = !this.moreCondition
    },
    openAddSysDocumentModal() {
      this.componentShow = 'addSysDocumentView'
      this.$nextTick(() => {
        this.$refs.addSysDocumentView.open()
      })
    },
    openEditSysDocumentModel(row) {
      this.componentShow = 'editSysDocumentView'
      this.$nextTick(() => {
        this.$refs.editSysDocumentView.open(row)
      })
    },
    openDeleteSysDocumentModel(row) {
      this.$refs.deleteSysDocument.open(row)
    },
    handleCloseAdd() {
      this.componentShow = 'sysDocumentList'
      this.listSysDocuments()
    },
    handleCloseEdit() {
      this.componentShow = 'sysDocumentList'
      this.listSysDocuments()
    },
    handleCloseDelete() {
      this.listSysDocuments()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>